import { createSlice } from "@reduxjs/toolkit";
const OfferSlice = createSlice({
  name: "offer",
  initialState: {
    offerConfigData: {}, // key: config name, value: config object
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    // Clear status for the UI
    clearOfferStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },

    fetchOfferConfigRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOfferConfigSuccess: (state, action) => {
      const { name, data } = action.payload;
      state.loading = false;
      state.offerConfigData[name] = data;
    },
    fetchOfferConfigFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    saveOfferConfigRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    saveOfferConfigSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
    },
    saveOfferConfigFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  fetchOfferConfigRequest,
  fetchOfferConfigSuccess,
  fetchOfferConfigFailure,
  saveOfferConfigRequest,
  saveOfferConfigSuccess,
  saveOfferConfigFailure,
  clearOfferStatus,
} = OfferSlice.actions;

export default OfferSlice.reducer;